import React, { useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AdminNavContext } from './AdminLayout';

/** Nested admin pages and the section home their ← returns to. */
const NESTED_HOME: { match: RegExp; home: string }[] = [
  { match: /^\/admin\/users\/[^/]+\/?$/, home: '/admin/users' },
  { match: /^\/admin\/mailer\/[^/]+(\/.*)?$/, home: '/admin/mailer' },
];

/** "←" before an admin page title.
 *  - Nested page (e.g. a user's detail): goes to that section's home.
 *  - Section home: opens the admin menu drawer (hidden on wide screens, where the menu is
 *    always visible). */
const AdminBackButton: React.FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { openNav } = useContext(AdminNavContext);
  const nested = NESTED_HOME.find((n) => n.match.test(pathname));

  const onClick = () => {
    if (nested) navigate(nested.home);
    else openNav();
  };
  const label = nested ? 'Back' : 'Open menu';

  return (
    <button
      type="button"
      className={`admin-back-btn${nested ? '' : ' admin-back-btn--menu'}`}
      onClick={onClick}
      aria-label={label}
      title={label}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M20 12H4M11 5l-7 7 7 7" />
      </svg>
    </button>
  );
};

export default AdminBackButton;
